/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Automatic_Save_Project_Save_FailedInputs */



/**
* | output |
* | --- |
* | "Project saved failed. {message}" |
*
* @param {Automatic_Save_Project_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_project_save_failed = /** @type {((inputs: Automatic_Save_Project_Save_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Project_Save_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l’enregistrement du projet. ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Projektspeicherung fehlgeschlagen. ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Progetto salvato non riuscito. ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Проект не удалось сохранить. ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El proyecto guardado falló. ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`项目保存失败。${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プロジェクトの保存に失敗しました。${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रोजेक्ट सेव करने में विफल। ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Projeto salvo falhou. ${i?.message}`)
	return /** @type {LocalizedString} */ (`Project saved failed. ${i?.message}`)
});